import { useTranslation } from "react-i18next";
import { useReflection } from "@/lib/hooks/useReflection";

export function SmallProgress() {
	const { service: reflectionService, isLoading: reflectionLoading } = useReflection();
	const { t } = useTranslation();

	if (reflectionLoading)
		return (
			<div className="border-brown-300 flex w-full max-w-60 items-center gap-2 rounded-full border-2 p-1 px-3">
				<div className="bg-brown-300 h-2 grow rounded-full" />
				<div className="text-brown-700 text-xs">{t("reflection.small-progress.loading")}</div>
			</div>
		);

	const { current, total } = reflectionService.getProgress();

	return (
		<div className="border-brown-300 flex w-full max-w-60 items-center gap-2 rounded-full border-2 p-1 px-3">
			<div className="bg-brown-300 h-2 grow rounded-full">
				<div
					className="bg-brown-400 h-full rounded-full"
					style={{ width: `max(8px, ${((current + 1) / total) * 100}%)` }}
				/>
			</div>
			<div className="text-brown-700 text-xs">
				{t("reflection.small-progress.text", { count: current + 1, target: total })}
			</div>
		</div>
	);
}
